import angular from 'angular';

import generalModule from './general';

export default angular.module('portainer.settings', [generalModule]).name;
